<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-readed`]" width="1em" height="1em" v-bind="$attrs"><path d="M9.86291 4.28989C10.1217 4.02945 10.5428 4.02827 10.8033 4.28696C11.0638 4.54585 11.0652 4.96689 10.8063 5.22739L4.36681 11.7079C4.24202 11.8332 4.07204 11.9041 3.89513 11.9041C3.71821 11.9041 3.54822 11.8333 3.42345 11.7079L0.606072 8.8729C0.347244 8.61244 0.348652 8.19039 0.609002 7.93149C0.869441 7.67294 1.2906 7.67426 1.54943 7.93442L3.89513 10.2948L9.86291 4.28989ZM14.4498 4.28989C14.7086 4.02946 15.1297 4.02831 15.3903 4.28696C15.6508 4.54585 15.6521 4.96689 15.3932 5.22739L8.95373 11.7079C8.69487 11.9679 8.27368 11.9693 8.0133 11.7108C7.75299 11.452 7.75192 11.0309 8.01037 10.7704L14.4498 4.28989Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineReaded',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
